import { useEffect, useRef, useState } from 'react';

const useDebouncedValue = <T>(value: T, delay = 500) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const firstRender = useRef(true);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (firstRender.current) {
                firstRender.current = false;
                return;
            }
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};

export default useDebouncedValue;
